/**
 * Photo Timeline Block
 *
 * UI for handling the logic and animations of Photo Timeline
 */

const $ = require( 'jquery' );

var itblPhotoTimeline = function(el){

  //setup some variables
  this.$el      = $(el);
  this.$toggle    = this.$el.find('.js-year-select');

  this.init();
};

itblPhotoTimeline.prototype.init = function(){

  this.events();

};

itblPhotoTimeline.prototype.events = function(){
  this.$toggle.on('click', this.event__handleShowPhoto.bind(this));
};

itblPhotoTimeline.prototype.event__handleShowPhoto = function(event){
  event.preventDefault();

  if(!$(event.currentTarget).hasClass('active-year')) {
    let el     = event.currentTarget.getAttribute('data-id');

    if(event.currentTarget.getAttribute('data-ismobile')){
      $('.mobile-years-expanded').removeClass('mobile-years-expanded');
    }

    $('.js-year-select.active-year').removeClass('active-year');
    $('.itbl-c-photo_timeline__photo.active-year').removeClass('active-year');

    $(el + '__year').addClass('active-year');
    $(el + '__image').addClass('active-year');
  }
  else {
    if(event.currentTarget.getAttribute('data-ismobile')){
      $(event.currentTarget).parent().toggleClass('mobile-years-expanded');
    }
  }
}

$(document).ready(function(){
  $('.itbl-c-photo-timeline').each(function(){
    new itblPhotoTimeline(this);
  });
}); 
